import { format, parse } from "date-fns";
import { es } from "date-fns/locale";

export const existsEvento = (eventos, data) => {
  return eventos.filter((e) => !data.some((d) => d.id === e.id));
};

export const convertirFecha = (fecha) => {
  // Lista de meses en español
  const mesesEnEspanol = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];

  // Separamos la fecha en partes
  const fechaSplit = fecha.split(" ");

  // Convertimos la fecha al formato yyyy-mm-dd
  const dia = fechaSplit[1];
  const mes = mesesEnEspanol.indexOf(fechaSplit[3]) + 1; // +1 porque los meses comienzan en 0
  const anio = fechaSplit[5];

  // Aseguramos que el mes y el día tengan dos dígitos (ejemplo: 09 para septiembre)
  const mesFormateado = mes < 10 ? `0${mes}` : mes;
  const diaFormateado = dia < 10 ? `0${dia}` : dia;

  // Retornamos la fecha formateada
  return `${anio}-${mesFormateado}-${diaFormateado}`;
};

export const obtenerFechasExtremas = (fechas_funciones) => {
  // Extraer todas las fechas del array de objetos
  const fechas = fechas_funciones.flatMap((item) =>
    item.fechas.map((fecha) => convertirFecha(fecha))
  );

  // Filtrar fechas no válidas
  const fechasValidas = fechas.filter((fecha) => fecha !== null);

  // Verificar si hay fechas válidas
  if (fechasValidas.length === 0) {
    console.error("No hay fechas válidas.");
    return { fechaMasViejaFormateada: null, fechaMasRecienteFormateada: null };
  }

  console.log("Fechas válidas:", fechasValidas); // Verificar las fechas que son válidas

  // Convertir las fechas a objetos Date para comparación
  const fechasObjetos = fechasValidas.map((fecha) => new Date(fecha));

  // Ordenar las fechas de más antigua a más reciente
  fechasObjetos.sort((a, b) => a - b);

  // La fecha más antigua será la primera y la más reciente la última
  const fechaMasVieja = fechasObjetos[0];
  const fechaMasReciente = fechasObjetos[fechasObjetos.length - 1];

  return {
    fechaAnterior: format(fechaMasVieja, "yyyy-MM-dd").toString(),
    fechaSiguiente: format(fechaMasReciente, "yyyy-MM-dd").toString(),
  };
};

export const crearArrayFechas = (inicio, fin) => {
  const mesesEnEspanol = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  const diasDeLaSemana = [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ];
  const fechas = [];
  let fechaActual = new Date(inicio);

  // Convertir la fecha de fin a un objeto Date
  const fechaFin = new Date(fin);

  // Iterar hasta llegar a la fecha final
  while (fechaActual <= fechaFin) {
    // Obtener el día de la semana
    const diaSemana = diasDeLaSemana[fechaActual.getDay()];
    
    // Obtener el día del mes
    const dia = fechaActual.getDate();
    
    // Obtener el mes en español
    const mes = mesesEnEspanol[fechaActual.getMonth()];
    
    // Obtener el año
    const anio = fechaActual.getFullYear();
    
    // Crear el formato 'viernes, 17 de noviembre de 2024'
    const fechaFormateada = `${diaSemana}, ${dia} de ${mes} de ${anio}`;
    fechas.push({fechas: [fechaFormateada], limite: 1});

    // Sumar un día a la fecha actual
    fechaActual.setDate(fechaActual.getDate() + 1);
}

  return fechas;
};
